import * as React from 'react';

import { useTheme } from '../../../../../theme';
import { Tooltip } from '../../../../../BaseComponents';

import { CdnIcon } from '@shared/ui';
import { FareBreakdown, FareBreakdownProps } from '../FareBreakdown';
import cn from 'classnames';
import { useShowTaxesInfo } from '../../../../../hooks';

interface Props {
	className?: string;
	children?: JSX.Element;
	breakdown: FareBreakdownProps['breakdown'];
}

const TaxesTooltip: React.FC<Props> = ({ className, children, breakdown }) => {
	const { TaxesTooltip: theme } = useTheme('Entities').Fare;
	const showTaxesInfo = useShowTaxesInfo();

	const content = breakdown.groups.length > 0 && <FareBreakdown breakdown={breakdown} />;

	if (!showTaxesInfo || !content) {
		return null;
	}

	return (
		<span className={cn(theme.root, className)}>
			<Tooltip
				title={content}
				placement="bottom-end"
				enterTouchDelay={0}
				PopperProps={{
					modifiers: [
						{ name: 'flip', enabled: true },
						{ name: 'preventOverflow', enabled: true }
					]
				}}
			>
				{children ?? (
					<div className={theme.price__iconWrapper}>
						<CdnIcon className={theme.price__icon} icon="Info/Details" />
					</div>
				)}
			</Tooltip>
		</span>
	);
};

export default TaxesTooltip;
